var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E0E8E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54075 10.3846C8.15022 10.7752 7.51706 10.7752 7.12653 10.3846L6.32514 9.58323C6.09737 9.35546 5.72808 9.35546 5.50031 9.58323C5.27254 9.811 5.27254 10.1803 5.50031 10.4081L7.12653 12.0343C7.51706 12.4248 8.15022 12.4248 8.54075 12.0343L13.0836 7.4914C13.3114 7.26363 13.3114 6.89434 13.0836 6.66657C12.8559 6.4388 12.4866 6.4388 12.2588 6.66657L8.54075 10.3846Z",
    fill: "#00806E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSuccess);
export default __webpack_public_path__ + "static/media/Step_success.9bb96dd50154d905217ae88a8c361ac8.svg";
export { ForwardRef as ReactComponent };